<template>
  <nav class="panel">
    <p class="panel-heading">
      Components List <span class="loader" v-if="!components.length"></span>
    </p>
    <a class="panel-block has-background-white-bis">
      <div class="columns">
        <div class="column">
          <strong>ID</strong>
        </div>
        <div class="column">
          <strong>Description</strong>
        </div>
        <div class="column"></div>
      </div>
    </a>
    <div class="panel-container">
      <a class="panel-block" :key="index" v-for="(item, index) in components">
        <div class="columns">
          <div class="column">
            <i class="ion-md-alert has-text-danger" v-if="!item.products"></i>
            {{item.id}}
          </div>
          <div class="column">
            {{item.description}}
          </div>
          <div class="column">
            <div class="buttons are-small is-right">
              <router-link class="button is-small" :to="{ name: 'updateComponent', params: { id: item.id } }">Manage</router-link>
              <a class="button is-danger is-outlined is-small" @click="deleteComponent(item.id, index)">
                <span>Delete</span>
                <span class="icon is-small">
                  <i class="icon ion-md-close"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </a>
    </div>
  </nav>
</template>

<script>
import errorHandler from '@/errorHandler';

export default {
  props: ['components'],

  methods: {
    deleteComponent(componentID, index) {
      fetch(`/api/component/${componentID}/delete`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(res => res.json())
        .catch(error => errorHandler(error))
        .then((response) => {
          if (response.status === 'FAILED_DEPENDENCY') {
            this.$awn.alert(`${response.message}`);
          } else {
            this.components.splice(index, 1);
            this.$awn.success(`${response.message}`);
          }
        });
    },
  },

};
</script>

<style lang="scss" scoped>
  .panel-container {
    height: 40vh;
    overflow: scroll;
  }

  .panel-block {
    display: block;
  }
</style>
